import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    inject,
} from "@angular/core";

import { Subscription } from "rxjs";

import { BlockMediaTextDeprecated, CTAVto } from "@hermes/api-model-editorial";

import { vtoTokenList } from "@hermes/fragments/editorial-cta-resolver";
import { FeatureFlagFacade, NEW_CTA_VTO } from "@hermes/states/flipper";

import { CHAPTERS_PARAGRAPH, SHOULD_PRELOAD_MEDIA } from "../../core";

@Component({
    selector: "h-block-media-text",
    templateUrl: "./block-media-text.component.html",
    styleUrls: ["./block-media-text.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BlockMediaTextComponent implements OnDestroy {
    blockMediaText = inject<BlockMediaTextDeprecated>(CHAPTERS_PARAGRAPH);
    private featureFlagFacade = inject(FeatureFlagFacade);
    public shouldPreloadMedia = inject(SHOULD_PRELOAD_MEDIA);

    public vtoDataArray: CTAVto[] = [];

    private subscription = new Subscription();

    constructor() {
        const blockMediaText = this.blockMediaText;

        this.subscription.add(
            this.featureFlagFacade
                .isActivated(NEW_CTA_VTO)
                .subscribe((isEnable: boolean) => {
                    if (isEnable && blockMediaText.tokens) {
                        this.vtoDataArray = vtoTokenList(blockMediaText.tokens);
                    }
                }),
        );
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
